var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn reports" },
    [
      _c(
        "b-card",
        {
          staticClass: "received-form",
          attrs: { "no-body": "", "bg-variant": "light" }
        },
        [
          _c(
            "b-row",
            {
              staticClass: "p-0 d-flex align-items-center",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "col",
                  staticStyle: { "z-index": "100" },
                  attrs: { md: "3" }
                },
                [
                  _c("multiselect", {
                    staticClass: "custom-multiselect",
                    attrs: {
                      limit: 1,
                      placeholder: "Filter by Username",
                      options: _vm.setUsernames,
                      "track-by": "text",
                      label: "text",
                      multiple: true
                    },
                    model: {
                      value: _vm.usernames,
                      callback: function($$v) {
                        _vm.usernames = $$v
                      },
                      expression: "usernames"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "col",
                  staticStyle: { "z-index": "100" },
                  attrs: { md: "3" }
                },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        ref: "searchInput",
                        attrs: { placeholder: "Search by File Name/ Status" },
                        on: { input: _vm.filterBySearch }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col", attrs: { md: "3" } },
                [
                  _c(
                    "b-row",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "mt-auto", attrs: { md: "1.5" } },
                        [
                          _c("h6", [
                            _vm._v(_vm._s(_vm.$t("COMMON.DATE_RANGE")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("date-picker", {
                            attrs: {
                              range: "",
                              lang: "en",
                              shortcuts: _vm.shortcuts,
                              format: "YYYY-MM-DD",
                              "append-to-body": "",
                              clearable: false,
                              width: "210px"
                            },
                            model: {
                              value: _vm.dateRange,
                              callback: function($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "col", attrs: { md: "3" } },
                [
                  _c("b-row", [
                    _c(
                      "div",
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-auto",
                            staticStyle: { "margin-right": "3px" },
                            on: { click: _vm.fetchProcessedForms }
                          },
                          [_vm._v("Fetch")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "mt-auto",
                            staticStyle: { "margin-right": "3px" },
                            on: { click: _vm.clearFilters }
                          },
                          [_vm._v("Clear")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "mt-1 panel-option",
                            attrs: { "no-caret": "" }
                          },
                          [
                            _c("template", { slot: "button-content" }, [
                              _c("div", [
                                _c("i", {
                                  staticClass: "fa fa-cloud-download",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              { on: { click: _vm.downloadFormsInsights } },
                              [_vm._v("Download")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              { on: { click: _vm.downloadAllFormLogs } },
                              [_vm._v("Download View Logs")]
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "forms-table" },
            [
              _vm.showProcessedForms
                ? _c("b-table", {
                    attrs: {
                      "show-empty": "",
                      striped: "",
                      "empty-text": _vm.$t("COMMON.NO_RECORD"),
                      hover: "",
                      responsive: "sm",
                      variant: "danger",
                      filter: _vm.searchFilter,
                      items: _vm.dailyReports,
                      fields: _vm.tableFields,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc
                    },
                    on: {
                      "update:sortBy": function($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function($event) {
                        _vm.sortDesc = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "HEAD_title",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "title",
                        fn: function(data) {
                          return [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName:
                                      "v-b-tooltip.hover.d100.topleft.viewport",
                                    modifiers: {
                                      hover: true,
                                      d100: true,
                                      topleft: true,
                                      viewport: true
                                    }
                                  }
                                ],
                                attrs: { title: data.item.title }
                              },
                              [_vm._v(_vm._s(data.item.title))]
                            )
                          ]
                        }
                      },
                      {
                        key: "HEAD_username",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "username",
                        fn: function(data) {
                          return [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.viewport",
                                    modifiers: { viewport: true }
                                  }
                                ],
                                attrs: { title: data.item.username }
                              },
                              [_vm._v(_vm._s(data.item.username))]
                            )
                          ]
                        }
                      },
                      {
                        key: "HEAD_document_type",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "document_type",
                        fn: function(data) {
                          return [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.viewport",
                                    modifiers: { viewport: true }
                                  }
                                ],
                                attrs: { title: data.item.document_type }
                              },
                              [_vm._v(_vm._s(data.item.document_type))]
                            )
                          ]
                        }
                      },
                      {
                        key: "HEAD_total_page_count",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "HEAD_average_confidence",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "HEAD_total_fields",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "HEAD_transcribed_fields",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "HEAD_accuracy_percentage",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "HEAD_edited_fields",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "HEAD_status",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "status",
                        fn: function(data) {
                          return [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.viewport",
                                    modifiers: { viewport: true }
                                  }
                                ],
                                attrs: { title: data.item.status }
                              },
                              [_vm._v(_vm._s(data.item.status))]
                            )
                          ]
                        }
                      },
                      {
                        key: "HEAD_created_at",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "created_at",
                        fn: function(data) {
                          return [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.viewport",
                                    modifiers: { viewport: true }
                                  }
                                ],
                                attrs: { title: data.item.created_at }
                              },
                              [_vm._v(_vm._s(data.item.created_at))]
                            )
                          ]
                        }
                      },
                      {
                        key: "HEAD_updated_at",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "updated_at",
                        fn: function(data) {
                          return [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.viewport",
                                    modifiers: { viewport: true }
                                  }
                                ],
                                attrs: { title: data.item.updated_at }
                              },
                              [_vm._v(_vm._s(data.item.updated_at))]
                            )
                          ]
                        }
                      },
                      {
                        key: "HEAD_document_recieved_at",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "document_recieved_at",
                        fn: function(data) {
                          return [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.viewport",
                                    modifiers: { viewport: true }
                                  }
                                ],
                                attrs: { title: data.item.document_recieved_at }
                              },
                              [_vm._v(_vm._s(data.item.document_recieved_at))]
                            )
                          ]
                        }
                      },
                      {
                        key: "HEAD_time_difference",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "HEAD_actions",
                        fn: function(data) {
                          return [
                            _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                          ]
                        }
                      },
                      {
                        key: "actions",
                        fn: function(data) {
                          return [
                            _c(
                              "div",
                              { staticClass: "btn btn-group" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.viewport",
                                        modifiers: {
                                          hover: true,
                                          viewport: true
                                        }
                                      }
                                    ],
                                    staticClass: "btn-primary btn-sm",
                                    staticStyle: { "margin-right": "7px" },
                                    attrs: { title: "View Logs" },
                                    on: {
                                      click: function($event) {
                                        _vm.showLogs(data.item.id, 1)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-file",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.viewport",
                                        modifiers: {
                                          hover: true,
                                          viewport: true
                                        }
                                      }
                                    ],
                                    staticClass: "btn-primary btn-sm",
                                    attrs: { title: "Download CSV" },
                                    on: {
                                      click: function($event) {
                                        _vm.downloadFormLogs(
                                          data.item.id,
                                          data.item.title
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-cloud-download"
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _c(
                    "content-placeholders",
                    [_c("content-placeholders-text", { attrs: { lines: 12 } })],
                    1
                  ),
              _vm._v(" "),
              _c(
                "infinite-loading",
                {
                  ref: "infiniteLoading",
                  attrs: { distance: _vm.distance, spinner: "spiral" },
                  on: { infinite: _vm.dailyReportsInfinetHandler }
                },
                [
                  _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
                  _vm._v(" "),
                  _c("div", {
                    attrs: { slot: "no-results" },
                    slot: "no-results"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "formLogsTable",
          attrs: { title: "Form Logs", size: "lg", centered: "" },
          on: {
            hidden: function($event) {
              ;(_vm.auditLogs = []), (_vm.isLogsLoaded = false)
            }
          }
        },
        [
          _c("b-container", { attrs: { fluid: "" } }, [
            _vm.auditLogs.length && _vm.isLogsLoaded
              ? _c(
                  "div",
                  { staticClass: "forms-table" },
                  [
                    _c("b-table", {
                      attrs: {
                        striped: "",
                        hover: "",
                        bordered: true,
                        fields: _vm.logFields,
                        items: _vm.auditLogs,
                        "per-page": _vm.logsPerPage,
                        "current-page": _vm.logsCurrentPage,
                        "aria-controls": "logs-table"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "file_name",
                          fn: function(data) {
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.d100.topleft.viewport",
                                      modifiers: {
                                        hover: true,
                                        d100: true,
                                        topleft: true,
                                        viewport: true
                                      }
                                    }
                                  ],
                                  staticClass: "ellipsis",
                                  attrs: { title: data.item.file_name }
                                },
                                [_vm._v(_vm._s(data.item.file_name))]
                              )
                            ]
                          }
                        },
                        {
                          key: "field_name",
                          fn: function(data) {
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.d100.topleft.viewport",
                                      modifiers: {
                                        hover: true,
                                        d100: true,
                                        topleft: true,
                                        viewport: true
                                      }
                                    }
                                  ],
                                  staticClass: "ellipsis",
                                  attrs: { title: data.item.field_name }
                                },
                                [_vm._v(_vm._s(data.item.field_name))]
                              )
                            ]
                          }
                        },
                        {
                          key: "original_text",
                          fn: function(data) {
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.d100.topleft.viewport",
                                      modifiers: {
                                        hover: true,
                                        d100: true,
                                        topleft: true,
                                        viewport: true
                                      }
                                    }
                                  ],
                                  staticClass: "ellipsis",
                                  attrs: { title: data.item.original_text }
                                },
                                [_vm._v(_vm._s(data.item.original_text))]
                              )
                            ]
                          }
                        },
                        {
                          key: "modified_text",
                          fn: function(data) {
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.d100.topleft.viewport",
                                      modifiers: {
                                        hover: true,
                                        d100: true,
                                        topleft: true,
                                        viewport: true
                                      }
                                    }
                                  ],
                                  staticClass: "ellipsis",
                                  attrs: { title: data.item.modified_text }
                                },
                                [_vm._v(_vm._s(data.item.modified_text))]
                              )
                            ]
                          }
                        },
                        {
                          key: "updated_by",
                          fn: function(data) {
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.d100.topleft.viewport",
                                      modifiers: {
                                        hover: true,
                                        d100: true,
                                        topleft: true,
                                        viewport: true
                                      }
                                    }
                                  ],
                                  staticClass: "ellipsis",
                                  attrs: { title: data.item.updated_by }
                                },
                                [_vm._v(_vm._s(data.item.updated_by))]
                              )
                            ]
                          }
                        },
                        {
                          key: "updated_at",
                          fn: function(data) {
                            return [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName:
                                        "v-b-tooltip.hover.d100.topleft.viewport",
                                      modifiers: {
                                        hover: true,
                                        d100: true,
                                        topleft: true,
                                        viewport: true
                                      }
                                    }
                                  ],
                                  staticClass: "ellipsis",
                                  attrs: { title: data.item.updated_at }
                                },
                                [_vm._v(_vm._s(data.item.updated_at))]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("b-pagination", {
                      attrs: {
                        align: "center",
                        id: "logs-table",
                        "total-rows": _vm.logsRow,
                        "per-page": _vm.logsPerPage
                      },
                      model: {
                        value: _vm.logsCurrentPage,
                        callback: function($$v) {
                          _vm.logsCurrentPage = $$v
                        },
                        expression: "logsCurrentPage"
                      }
                    })
                  ],
                  1
                )
              : _vm.isLogsLoaded
                ? _c("div", [_vm._v("\n          No logs available\n        ")])
                : _c(
                    "div",
                    [
                      _c(
                        "content-placeholders",
                        [
                          _c("content-placeholders-img", {
                            staticStyle: { height: "765px" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "dark" },
                  on: {
                    click: function($event) {
                      _vm.$refs.formLogsTable.hide()
                    }
                  }
                },
                [_vm._v(" Close ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d1dbfa0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1dbfa0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/reports/auditLogs.vue
// module id = 1266
// module chunks = 2